import Gift from "@sumerkit/icons/gift/ssr";
import { useTranslation } from "react-i18next";
import { Product } from "~/common/props/orchestrator";
import styles from "./product-cloud-tags.module.css";

export const ProductCloudTags = ({
  product,
  className



}: {product: Product;className?: string;}) => {
  const { t } = useTranslation();

  return (
    <div
      aria-label='product-tags'
      className={`${styles.ProductSkin1Tags} ${className || ""}`}>

      {product?.kit &&
      <div
        className={`${styles.productDetailTag} ${styles.productDetailTag__kit}`}>

          <Gift className={`${styles.productDetailTagIcon}`} /> Combo
        </div>}

      {product?.highlight &&
      <div
        className={`${styles.productDetailTag} ${styles.productDetailTag__highlight}`}>

          <span className='icon-star-fill'></span> {t("product.tag_highlight")}
        </div>}

      {product?.wholesale?.configurations &&
      <div
        className={`${styles.productDetailTag} ${styles.productDetailTag__wholesale}`}>

          <span className='icon-light-package'></span>
          {t("product.tag_wholesale")}
        </div>}

    </div>);

};